module.exports = __webpack_public_path__ + "img/mv.1d3c5e96.png";